<script setup lang="ts">
import {PropType} from "vue";

const props = defineProps({
    letter: {
        type: String,
        required: false
    },
    text: {
        type: String,
        required: false
    }
})
</script>

<template>
    <div v-if="letter" class="bubble" :class="{followedByText: !!props.text}">
        {{letter}}
    </div>
    {{text}}
</template>

<style lang="scss" scoped>
.bubble {
    background-color: var(--ion-color-red);
    color: white;
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    border-radius: 0.6em;
    text-align: center;
    line-height: 1.1em;
    font-weight: bold;

    &.followedByText {
        margin-right: -0.1em;
    }
}
</style>
